import * as React from "react"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import {
  SiteDetailsDocument,
  SiteDetailsQuery,
  SiteDetailsQueryVariables,
} from "@modules/site/shared/queries.generated"
import { useToggleImageCdnMutation } from "@modules/cdn/shared/queries.generated"

const sessionKey = `hideImageCdnStaleSourceVersionNotification`

export function useToggleToggleImageCdn(siteId: string) {
  const [toggleImageCdnMutation, loading] = useToggleImageCdnMutation()
  const [setError, errorAlert] = useTriggerErrorAlert()
  const isBrowser = typeof window !== `undefined`
  const notificationKey = `${sessionKey}:${siteId}`
  const notificationVisibleInitValue =
    isBrowser && window.sessionStorage.getItem(notificationKey) ? false : true

  const [notificationVisible, setNotificationVisible] = React.useState(
    notificationVisibleInitValue
  )

  function hideNotification() {
    setNotificationVisible(false)
    window.sessionStorage.setItem(notificationKey, `1`)
  }

  const toggleImageCdn = () => {
    setError(null)
    return toggleImageCdnMutation({
      variables: {
        siteId,
      },
      update: (proxy, { data }) => {
        if (!data?.toggleImageCdnFlag?.success) {
          return
        }

        const queryInfo = {
          query: SiteDetailsDocument,
          variables: {
            id: siteId,
          },
        }

        const queryData = proxy.readQuery<
          SiteDetailsQuery,
          SiteDetailsQueryVariables
        >(queryInfo)

        if (typeof queryData?.siteDetails?.imageCdnEnabled !== `undefined`) {
          queryData.siteDetails.imageCdnEnabled = !queryData.siteDetails
            .imageCdnEnabled
        }

        proxy.writeQuery<SiteDetailsQuery, SiteDetailsQueryVariables>({
          ...queryInfo,
          data: {
            ...queryData,
          },
        })
      },
      optimisticResponse: {
        toggleImageCdnFlag: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return {
    toggleImageCdn,
    hideNotification,
    loading,
    errorAlert,
    notificationVisible,
  } as const
}
